import { Model } from '@vuex-orm/core'
import User from './User'

export default class Vacation extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'vacations'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.attr(null),
      starts_at: this.attr(''),
      ends_at: this.string(''),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id'),
    }
  }
}